<!-- 商品管理 V2 - 批量删除确认弹框 -->
<template>
  <el-dialog
    :title="$t('message.productV2DeletePrompt')"
    :visible.sync="visible"
    width="520px"
    append-to-body
    custom-class="delete-product-dialog"
  >
    <div class="delete-dialog-content">
      <p class="delete-warning">{{ $t('message.productV2DeleteWarning') }}</p>
      <div v-for="group in groups" :key="group.user_id" class="delete-customer-group">
        <p>{{ $t('message.clientID') }}：{{ group.user_id }}</p>
        <p>{{ group.client_sku_codes.join('，') }}</p>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="visible = false">{{ $t('message.cancel') }}</el-button>
      <el-button type="primary" :loading="loading" @click="submit">{{ $t('message.submit') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'DeleteProductDialog',
  data() {
    return {
      visible: false,
      loading: false,
      list: []
    }
  },
  computed: {
    groups() {
      const groups = {}
      this.list.forEach(item => {
        if (!groups[item.user_id]) {
          groups[item.user_id] = { user_id: item.user_id, client_sku_codes: [] }
        }
        groups[item.user_id].client_sku_codes.push(item.client_sku_code)
      })
      return Object.values(groups)
    }
  },
  methods: {
    open(list) {
      this.list = list.slice()
      this.visible = true
    },
    async submit() {
      this.loading = true
      try {
        let lastResponse = null
        for (const item of this.list) {
          lastResponse = await this.$api.productManagementApi.deleteProduct({
            user_id: Number(item.user_id),
            sys_code: item.sys_code
          })
        }
        this.$message.success((lastResponse && lastResponse.msg) || this.$t('message.successfullyDeleted'))
        this.visible = false
        this.$emit('success')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
.delete-product-dialog {
  .el-dialog__body { padding: 24px 28px 8px; }
  .delete-dialog-content { padding: 0 4px; }
  .delete-warning { margin: 0 0 24px; color: #f5222d; font-weight: 700; line-height: 20px; }
  .delete-customer-group { margin-bottom: 20px; }
  .delete-customer-group:last-child { margin-bottom: 0; }
  .delete-customer-group p { margin: 0 0 4px; line-height: 20px; word-break: break-all; }
}
</style>
